<template>
  <!-- <div>
    <div>
      <div>{{ viewNum }}</div>
    </div>
    <div v-if="showTotal">
      <div>({{ total }})</div>
    </div>
  </div> -->
  <div>
    {{ total }}
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // viewNum: "",
      total: "",
      // showTotal: true,
    };
  },
  methods: {
    setData() {
      let type = this.item.type.toLowerCase();
      if (
        [
          "article",
          "video",
          "video_collection",
          "audio_collection",
          "image_collection",
          "subject",
          "stream",
          "discuss",
        ].indexOf(type) != -1
      ) {
        // this.viewNum = this.item.viewNum || 0;
        // if (!this.item.operateViewNum) {
        //   this.showTotal = false;
        // } else {
        //   this.total =
        //     (this.item.viewNum || 0) + (this.item.operateViewNum || 0);
        // }
        this.total = (this.item.viewNum || 0) + (this.item.operateViewNum || 0);
      } else {
        this.total = "--";
        // this.viewNum = "--";
        // this.showTotal = false;
      }
    },
  },
  mounted() {
    this.setData();
  },
  watch: {
    item(val) {
      this.setData();
    },
  },
};
</script>

<style></style>
